import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Stack } from '@mui/material';
import { BenefitDTOBenefitEnum, MobilityBenefitOptionsDTOTaxationTypeEnum, TenantDTO } from 'probonio-shared-ui/api';
import { Trans } from 'react-i18next';
import { BenefitAttribute, BenefitColumnsExtensionInterface } from '../../../../extension/interface/benefit-columns.extension.interface';
import { NonCashIcon } from '../../coupons/extension/coupons-benefit-columns.extension';
import { NonCashBenefit } from '../../nonCashBenefit/const';

export class FlexBenefitColumnsExtension extends BenefitColumnsExtensionInterface {
  getBenefitAttributes: (context?: { tenant?: TenantDTO }) => BenefitAttribute[] = context => [
    {
      id: 'flexMonthlyBudget',
      accessorFn: value => value.flexOptions?.monthlyBudget,
      header: 'FLEX.fields.monthlyBudget',
      renderer: value => (typeof value === 'number' ? <Trans i18nKey="common:money" values={{ money: value }} /> : null),
    },
    ...((context?.tenant?.nonCashBenefits.length ?? 0) > 1
      ? [
          {
            id: 'flexNonCashBenefits',
            accessorFn: value => value.flexOptions?.nonCashBenefits,
            header: 'employeeTabs.header.nonCashBenefits',
            renderer: value =>
              value ? (
                <Stack
                  direction="row"
                  sx={{
                    alignItems: 'center',
                  }}
                >
                  {(value as NonCashBenefit[]).map(val => (
                    <NonCashIcon key={val} nonCashBenefit={val} />
                  ))}
                </Stack>
              ) : (
                []
              ),
          } satisfies BenefitAttribute,
        ]
      : []),
    ...(context?.tenant?.flexBenefits?.includes(BenefitDTOBenefitEnum.Mobility)
      ? [
          {
            id: 'flexMobilityTaxationType',
            accessorFn: value => value.flexOptions?.mobilityTaxationType,
            header: 'MOBILITY.fields.taxationTypeColumn',
            renderer: value =>
              value === MobilityBenefitOptionsDTOTaxationTypeEnum.Taxable ? (
                <CheckIcon color="success" />
              ) : value === MobilityBenefitOptionsDTOTaxationTypeEnum.TaxFree ? (
                <CloseIcon color="error" />
              ) : null,
          } satisfies BenefitAttribute,
        ]
      : []),
  ];
}
